import { useNavigate } from "react-router-dom";


function LoginBoom() {
    const navigate = useNavigate();
    
    const handleLoginClick = () => {
        navigate('/login');
    };
    
    const handleSignupClick = () => {
        navigate('/signup')
    };

    const handleCloseClick = () => {
        const loginboom = document.getElementById("login-signup-boom");
        loginboom.style.display = "none"
    };
    return (
        <>
            <div className="parent-loginboom">
                <div className="loginboom" id="login-signup-boom">
                    <div className="loginboom-cross-button" onClick={handleCloseClick}>
                        <i className="fas fa-times"></i>
                    </div>
                    <button
                        className="loginboom-button loginboom-login-button"
                        onClick={handleLoginClick}
                    >
                        Login
                    </button>
                    <button
                        className="loginboom-button loginboom-signup-button"
                        onClick={handleSignupClick}
                    >
                        Signup
                    </button>
                </div>
            </div>
        </>
    )

}

export default LoginBoom;